import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import SEOHead from "@/components/seo/SEOHead";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Home, Search } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <>
      <SEOHead 
        title="404 - Page Not Found | FlatJive"
        description="The page you're looking for doesn't exist. Return to FlatJive homepage to explore our share of freehold property management platform."
        noIndex={true}
        canonicalUrl={location.pathname}
      />
      
      <div className="min-h-screen flex flex-col bg-background">
        <Navbar />
        
        <main className="flex-1 flex items-center justify-center px-4 py-16">
          <div className="max-w-2xl mx-auto text-center">
            <div className="mb-8">
              <h1 className="text-display-lg text-foreground mb-4">404</h1>
              <h2 className="text-heading-lg text-foreground mb-6">Page Not Found</h2>
              <p className="text-body-lg text-muted-foreground mb-8">
                Sorry, we couldn't find the page you're looking for. The page may have been moved, 
                deleted, or the URL might be incorrect.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild size="lg">
                <Link to="/">
                  <Home className="mr-2 h-5 w-5" />
                  Return to Home
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg">
                <Link to="/insights/">
                  <Search className="mr-2 h-5 w-5" />
                  Browse Insights
                </Link>
              </Button>
            </div>
            
            <div className="mt-12 pt-8 border-t border-border">
              <p className="text-body-sm text-muted-foreground mb-4">
                Need help? Here are some useful links:
              </p>
              <nav className="flex flex-wrap gap-4 justify-center text-body-sm">
                <Link to="/" className="text-primary hover:text-primary/80 transition-colors">
                  Home
                </Link>
                <Link to="/pricing/" className="text-primary hover:text-primary/80 transition-colors">
                  Pricing
                </Link>
                <Link to="/insights/" className="text-primary hover:text-primary/80 transition-colors">
                  Insights
                </Link>
              </nav>
            </div>
          </div>
        </main>
        
        <Footer />
      </div>
    </>
  );
};

export default NotFound;
